import axios from "axios";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";

const PaymentLoading = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");

  useEffect(() => {
    const getDmiPaymentResponseApi = async () => {
      axios(
        `https://portal.acrossassist.com//api/partner/v1/dmi/GetPaymentStatusByUserId?UserId=${userId}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      )
        .then((res) => {
          if (res?.data?.data?.order_status === "Success") {
            navigate("/payment-success");
          } else {
            toast.success(res?.data?.status_message);
            navigate("/payment-failure");
          }
        })
        .catch(() => {
          navigate("/payment-failure");
        });
    };

    getDmiPaymentResponseApi();
  }, [userId, navigate]);

  return (
    <Container
      fluid
      className="d-flex vh-100 justify-content-center align-items-center bg-light"
    >
      <Row>
        <Col xs={12} className="text-center">
          <Spinner
            role="status"
            variant="primary"
            animation="border"
            style={{ width: "4rem", height: "4rem" }}
          />
          <h3 className="mt-4">Processing Your Payment...</h3>
          <p className="text-muted">Please do not refresh the page.</p>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentLoading;
